import './styles.scss'
import './index/index.scss'
import './orders/orders.scss'
import './profile/profile.scss'
import './wish-list/wish-list.scss'

import DomClass from './../../../js/classes/Dom.js'
import OrderClass from './../../../js/classes/Order.js'
import PersonalClass from './../../../js/classes/Personal.js'

//PROFILE
const personalForm = document.querySelector('.form_personal-bind')

if (personalForm) {
    const personalPhone = document.querySelector('#personal-phone')
    if (personalPhone) DomClass.setMask(personalPhone)

    personalForm.addEventListener('submit', (e) => {
        e.preventDefault()
        e.stopPropagation()

        const inputChecked = document.querySelector('input[name="personal-sex"]:checked'),
        params = {
            NAME : document.querySelector('#personal-name').value.trim(),
            LAST_NAME : document.querySelector('#personal-last-name').value.trim(),
            PERSONAL_PHONE : document.querySelector('#personal-phone').value.trim(),
            EMAIL : document.querySelector('#personal-email').value.trim(),
            SECOND_NAME : document.querySelector('#personal-second-name').value.trim(),
            PERSONAL_BIRTHDAY : document.querySelector('#personal-birthday').value.trim(),
            PERSONAL_GENDER : inputChecked ? inputChecked.value : ''
        }

        const submitButton = document.querySelector('#personal-submit'),
        submitButtonText = submitButton.textContent 

        submitButton.setAttribute('disabled', 'disabled')
        submitButton.textContent = 'Сохранение..'

        PersonalClass.save((err, res) => {
            submitButton.removeAttribute('disabled')
            submitButton.textContent = submitButtonText
        }, params)

        return false
    })
}

//PROFILE CARD NUMGER
const personalCardNumberForm = document.querySelector('.form_card_number-bind')

if (personalCardNumberForm) {
    const cardNumber = document.querySelector('#personal-card-number')

    personalCardNumberForm.addEventListener('submit', (e) => {
        e.preventDefault()
        e.stopPropagation()

        const params = {
            CARD_NUMBER : cardNumber.value.trim(),
        }

        const submitButton = document.querySelector('#card-number-submit'),
        submitButtonText = submitButton.textContent 

        submitButton.setAttribute('disabled', 'disabled')
        submitButton.textContent = 'Сохранение..'

        PersonalClass.changeCardNumber((err, res) => {
            submitButton.removeAttribute('disabled')
            submitButton.textContent = submitButtonText
        }, params)

        return false
    })
}

//CHANGE PASSWORD
const personalPasswordForm = document.querySelector('.form_personal-password-bind')

if (personalPasswordForm) {
    personalPasswordForm.addEventListener('submit', (e) => {
        e.preventDefault()
        e.stopPropagation()

        const passwordInput = document.querySelector('#personal-password'),
        newPasswordInput = document.querySelector('#personal-new-password'),
        confirmPasswordInput = document.querySelector('#personal-confirm-password'),
        params = {
            PASSWORD : passwordInput.value.trim(),
            NEW_PASSWORD : newPasswordInput.value.trim(),
            CONFIRM_PASSWORD : confirmPasswordInput.value.trim()
        }

        passwordInput.classList.remove('form__input_error')
        newPasswordInput.classList.remove('form__input_error')
        confirmPasswordInput.classList.remove('form__input_error')

        const submitButton = document.querySelector('#personal-password-submit'),
        submitButtonText = submitButton.textContent 

        submitButton.setAttribute('disabled', 'disabled')
        submitButton.textContent = 'Смена пароля..'

        PersonalClass.changePassword((err, res) => {
            submitButton.removeAttribute('disabled')
            submitButton.textContent = submitButtonText

            if (res === true) {
                passwordInput.classList.add('form__input_success')
                document.querySelector('#personal-new-password').classList.add('form__input_success')
                confirmPasswordInput.classList.add('form__input_success')
            } else {
                passwordInput.classList.add('form__input_error')
                newPasswordInput.classList.add('form__input_error')
                confirmPasswordInput.classList.add('form__input_error')
            }
        }, params)

        return false
    })
}

//ORDERS
document.querySelectorAll('.personal__order-data').forEach((orderNode) => {
    orderNode.addEventListener('click', () => {
        orderNode.parentNode.classList.toggle('personal__order_active')
    })
})

//Оплата заказа
document.querySelectorAll('.button_personal__payment-link').forEach((paymentButtonNode) => {
    paymentButtonNode.addEventListener('click', (e) => {
        e.preventDefault()
        e.stopPropagation()
        
        const ORDER_ID = parseInt(paymentButtonNode.getAttribute('data-order-id')),
        text = paymentButtonNode.textContent

        paymentButtonNode.textContent = 'Оплата заказа..'
        paymentButtonNode.setAttribute('disabled', 'disabled')

        OrderClass.getPaymentLink((err, res) => {
            paymentButtonNode.textContent = text
            paymentButtonNode.removeAttribute('disabled')

            if (err) {
                alert('Не удалось выполнить оплату ;(\r\nПожалуйста свяжитесь с нашим менеджером!');
            } else {
                document.location = res
            }
        }, { ORDER_ID })
        
        return false
    })
})